export default {
    template: require('./invoiceBiduleSleek.jade')(),
    bindings: {
        sleek: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceBiduleSleek.js